module.exports = __webpack_public_path__ + "0fda8acc8d54dbbcca88bfae86639d4e.pdf";